import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {oceanImportMblList, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';
import MoveTypeDropDown from "../../../uiControls/MoveTypeDropDown";
import {Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';

import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import cntrBlack from '../../../img/container_tracking-black.svg';
import cntrWhite from '../../../img/container_tracking-white.svg';

import {
  DateRenderer,DateTimeRenderer,
  FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import IfmsModal from '../../../ui/IfmsModal';
import {JobNames} from '../../../framework.core/JobNames';
import loadInfoAreaInvoiceBillCrDb from '../../../components/common/InfoAreaInvoiceBillCrDb';
import {OiMblListItem, OimListType} from '../../../fms.data/models/OiMblListItem';
import * as XCol from '../../../framework.core/XExportColumn';

import MblMilestonePopup from './MblMilestonePopup';
import fastStorage from '../../../fastStorage';
import Menu, {IfmsMenuItem} from '../../../ui/menu/Menu';
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { ShipmentTypeRenderer, ShipmentTypeFilterRenderer, LclFclFilterRenderer, BillInvoiceCrdbFilterRenderer, LclFclRenderer, RecognizedFilterRenderer, RecognizedRenderer, BillingsRenderer, TrackEventNameRenderer, RQFilterRenderer, LastEventRenderer } from '../../common/commonListRenderers';
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import TrackingRequest from '../../reports/TrackingRequest';
import _ from 'lodash';
import { ApiResult } from '../../../framework.core/data/ApiResult';
import EmailOptionPopup from '../../reports/EmailOption';
import { RequestType } from '../../../fms.core/TrackRequest';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { formatLclFcl, formatShipmentType } from '../../common/utils/formatUtils';
import { access } from 'fs';
import { formatDateTime } from '../../../dateUtils';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';

let vcResult:string = '';

function MoveTypeFilterRenderer({value, onChange}:any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}
    />
  );
}

// function IndicatorRenderer({value, data, row}: any) {
//   const jobListContext = useContext(JobListViewContext);
//   let content:React.ReactNode | null = null;

//   content = <span>{value}</span>;

//   function onIndicatorClick() {
//     if (jobListContext.rowExtrasId) {
//       return; // Some row is already selected
//     }

//     jobListContext.setRowExtrasId(data[row.index].id);
//   }

//   return (
//     <div style={{width: '100%', display: 'block'}} onClick={onIndicatorClick}>
//       {content}
//     </div>
//   );
// }

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];

  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';


  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }
  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt=""/>;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="Container Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`}  data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function HblRenderer({value, data, row}: any) {
  const {switchToHblFor} = useMblOperations();

  const isNumber = !isNaN(parseInt(value));

  if (!isNumber) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToHblFor(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

//<pt220202>
// function formatLclFcl(v:string) {
//   if(v === 'F') return 'FCL';
//   else if(v === 'L') return 'LCL';
//   else if(v === 'O') return 'FAK';
//   else return '';
// }


function useMblOperations() {
  const history = useHistory();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/hbl/oceanImport', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'oiMblId', 'Ref. #', mbl.id, 'update', false, true, null, 'refNo', mbl.refNo,false,true);
    openNewPage(history, `/common/joblistview/hbl/oceanImport`, NavigationType.newPage);
  }

  function switchToContainerFor(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/OICN/oceanImport', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'oiMblId', 'Ref. #', mbl.id, 'update', false, true, null, 'refNo', mbl.refNo, false, true);
    openNewPage(history, `/common/joblistview/OICN/oceanImport`, NavigationType.newPage);
  }


  function switchToAmsFor(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSM/ams', 
    //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
    // 'refNo', '', mbl.refNo ?? '', 'update', false);
    'amsLinkId', 'AMS ID', mbl.amsLinkId, 'update', false, true, null, null, null, false, true);
    openNewPage(history, `/common/joblistview/AMSM/ams`, NavigationType.newPage);
  }

  async function switchToAcctInfo(mbl:OiMblListItem|null) {
    if (!mbl) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.OIMbl}/${mbl.id}`, NavigationType.newPage);
  }

  return { switchToHblFor, switchToContainerFor, switchToAmsFor ,switchToAcctInfo};
}

function useSelectedMblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const { switchToHblFor, switchToContainerFor, switchToAmsFor } = useMblOperations();

  const selectedElement = jobListContext.selectedElement as OiMblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');
  
  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, '/oceanImport/mbl/add', NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    if ((selectedElement.hblCount !== 'DBL' && selectedElement.hblCount !== 'X' && selectedElement.hblCount !== '0')) {
      await showGlobalOkDialog('Need to delete HBL first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close MBL first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OIMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OIMB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OIMbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null, 'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanImport/mbl/edit/${id}`;
    const viewUrl = `/oceanImport/mbl/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanImport/mbl/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/viewBillings/mbl/${id}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OIMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    
    const editUrl  = `/oceanImport/mbl/edit/${id}`;
    const viewUrl = `/oceanImport/mbl/view/${id}`;
    //let url = `/oceanImport/mbl/${viewEdit ? 'edit' : 'view'}/${id}`;
    let editUrlProfitTab = `${editUrl}/2`;
    let viewUrlProfitTab = `${viewUrl}/2`;

    if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/oceanImport/mbl/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }


  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanImport/mbl/edit/${id}`;
    const viewUrl = `/oceanImport/mbl/view/${id}`;
    
    const listSec = findSecurityTask(appContext, FmsSecTask.OIMbl);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanImport/mbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHbl() {
    const selectedElement = jobListContext.selectedElement as OiMblListItem;
    if (selectedElement?.hblCount !== 'DBL') switchToHblFor(selectedElement);
  }

  function switchToContainer() {
    const selectedElement = jobListContext.selectedElement as OiMblListItem;
    switchToContainerFor(selectedElement);
  }

  function switchToAms() {
    const selectedElement = jobListContext.selectedElement as OiMblListItem;
    switchToAmsFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  async function trackRequestFunc(jobName:JobNames) {
    if (!selectedElement) {
      return;
    }

    if (_.isEmpty(selectedElement.mblNo) || _.isEmpty(selectedElement.containerNo)) {
      await showGlobalOkDialog(<p>Master B/L number is empty or Master B/L has no container.</p>, false, null, 'warning');
      return;
    }

    const plusIndex = selectedElement.containerNo.indexOf('+');
    let containerCount: number = 1;

    if (plusIndex !== -1) containerCount = Number(selectedElement.containerNo.substring(plusIndex + 1).trim()) + 1

    await CheckAndDoTrackRequest(jobName, selectedElement.id, selectedElement.trType, selectedElement.trStatus, selectedElement.mblNo, containerCount)
  }

  async function CheckAndDoTrackRequest(jobName: string, jobId: number, trType: string, trStatus: string, mblNo: string, cntrCount: number = 1) {
    let result: string = '';
    if (!await CheckTrStatus(jobId, trType, trStatus, cntrCount)) return result;
    
    const apiResult = await IsShippingLineSupported(mblNo?.substring(0, 4), jobName === JobNames.OIMbl ? RequestType.bl : RequestType.Container)
    if (!apiResult.success || (jobName === JobNames.OIContainer && apiResult.result === RequestType.bl))
      return result;

    vcResult = apiResult.result;

    const errMsg = await CheckTrackRequestAllowed(cntrCount)
    if(!_.isEmpty(errMsg)){
      if (!errMsg.endsWith('?')){
        await showGlobalOkDialog(<p>{errMsg}</p>);
        return result;
      }
      else{
        const doClose = await showGlobalYesNoDialog(
          <div>
            <h3>{errMsg}</h3>
          </div>
        ,false, 0, true);
  
        if (!doClose) {
          return result;
        }
      }
    }

    jobListContext.setRowExtrasId(jobId);
    jobListContext.setTrackingRequestEmailList('OpenTrackRequestNewMode');
  }

  async function CheckTrackRequestAllowed(countToSend: number) {
    let result = '';

    const perMonth = appContext.suntekSettings?.company?.containersPerMonth ?? 0;
    if (perMonth > 0) {
      const apiResult = await appContext.api.checkThisMonthRequests();
      if (perMonth - apiResult < countToSend) {
        result = `Credit for containers per month is limited.
This request will cause additional fee.
Do you want to request this tracking?`;
      }
    }
    return result;
  }

  async function IsShippingLineSupported(vcScac: string, reqType: string) {
    let apiResult: ApiResult<string> = { success: false, result: '', message: '' };

    if (_.isEmpty(vcScac)) {
      await showGlobalOkDialog(<p>Vessel carrier was not given. Please retry with valid Master B/L number.</p>);
      return apiResult;
    }

    apiResult = await appContext.api.trackingCheckShippingLine(vcScac);

    if(!apiResult || !apiResult.success){
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return apiResult;
    }
    else {
      switch (apiResult.result) {
        case 'X':
          await showGlobalOkDialog(<p>Tracking Service does not support Vessel carrier {`[${vcScac}]`}.</p>);
          apiResult.success = false;
          break;
        case RequestType.bl:
          if (reqType !== RequestType.bl) {
            await showGlobalOkDialog(<p>Vessel carrier {`[${vcScac}] support only Master B/L tracking.`}
Please retry from Master B/L list.</p>);
            apiResult.success = false;
          }
          break;
      }
    }
    return apiResult;
  }

  async function CheckTrStatus(jobId: number, trType: string, trStatus: string, cntrCount: number = 1) {
    if (!_.isEmpty(trType) && trType !== 'C') {
      jobListContext.setRowExtrasId(jobId);
      jobListContext.setTrackingRequestEmailList('OpenTrackRequestViewMode');
      return false;
    }
    return true;
  }

  return { create, deleteMbl, edit, view, copy, switchToHbl, switchToContainer, switchToAms, recognize, viewBillings, moveToDeleteHistoryReport, viewProfit, trackRequestFunc };
}

function RightClickMenu({dismiss, column, isStatus}:{dismiss: VoidFunction, column : number, isStatus : boolean}) {
  const { create, deleteMbl, edit, view, copy, switchToHbl, switchToContainer, switchToAms, recognize, viewBillings, moveToDeleteHistoryReport, viewProfit, trackRequestFunc } = useSelectedMblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.OIMbl);
  const fmsGlobal = getFmsGlobal();

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&mbl=${selectedElement.mblNo}&email=${appContext.user?.email}`);
  }

  function openContainerStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OIMbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${selectedElement.id}`)) {
      const editModelKey = `editOiMbl${selectedElement.id}-/oceanImport/mbl/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  let isTracking = (selectedElement?.trStatus && selectedElement?.trStatus !== 'C' && selectedElement?.trStatus !== 'failed' && selectedElement?.trStatus !== 'Q') ?? false;
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Container List', shortcut: 'F4', separator: false },
    { label: 'Go to AMS List', shortcut: 'Shift+F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false, disabled : selectedElement?.hblCount === 'DBL' },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    { label: 'Container Status Update', shortcut: '', separator: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
    { label: isTracking ? 'Request Email Notification' : 'Request Tracking Service', shortcut: '', separator: false, hidden: !appContext.suntekSettings?.company?.trackingService },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="oim-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  const menuStatus: ActionButtonItem[] = itemStatus.map((i, index) => ({
    label: <ToolboxMenuItem name="oim-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteMbl();
        break;
      case 4:
        switchToContainer();
        break;
      case 5:
        switchToAms();
        break;
      case 6:
        jobListContext.triggerTableSearch('F5');
        break;
      case 7:
        switchToHbl();
        break;
      case 8:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 9:
        copy();
        break;
      case 10:
        viewBillings();
        break;
      case 11:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 12:
        openContainerStatus();
        break;
      case 13:
        openContainerTracking();
        break;
      case 14:
        trackRequestFunc(JobNames.OIMbl);
        break;
      case 15:
        processFileLock();
        break;
      case 16:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  function onStatusSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        processFileLock();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={(column === 0 && isStatus) ? splitMenuItemsIntoSections(menuStatus) :  splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={(column === 0 && isStatus) ? onStatusSelected : onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ChbRenderer({ cell, row, data }:any) {
  const l = data[row.index];
  const tooltip = l.chbRspCode === 'x' ? undefined : `${l.chbRspCode} - ${l.chbRspMsg}`;
  return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={tooltip}>{cell.value}</div>;
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useMblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

// function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as OiMblListItem;

//   return (
//     <>
//       &nbsp;&nbsp;
//       <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking" name="oim-list-carrierTracking-button"
//         onClick={() => window.open(`http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mblNo}`)}>
//         <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
//       </BlackInverseButton>
//     </>
//   )
// }

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.OIMbl, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}


function MblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as OiMblListItem;
  const { deleteMbl, edit, view, copy, viewBillings, moveToDeleteHistoryReport, trackRequestFunc } = useSelectedMblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.OIHbl, JobNames.SlipJournal]);

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/view/${id}`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/mbl/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }
  
  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    if (fmsSubMenu === FmsSubMenu.STARCFSMANI) {
      var result = await appContext.api.makeCfsManifest(selectedElement?.id?.toString()||'0');
      if (result) {
        if (!result.item1) {
          await showGlobalOkDialog(<p>CFS/Contact not configured for email manifest. (Name='ediManifest', Dept=ID, EMail=Address).</p>, false, null, 'warning');
          return;
        } else if (result.item3){
          // FMS3.3 Code : FrmPrintPreview.RunEmptyReport(false, result.Item2, "Manifest", result.Item3, "T_OIMMAIN", tbId.ToInt());
          //await showGlobalOkDialog(<p>Not Implemented Yet <br/>(An email pop-up window should open.)</p>).then();
          return;
        }
      }
    } else {
      // Call ReportViewer 
      const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OIMbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
      if(args){
        viewReport(args, "", true);
      }
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }
  
  const listSec = findSecurityTask(appContext, FmsSecTask.OIMbl);
  
  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name ='oim-list-add-button' display="primary" size="regular" link="/oceanImport/mbl/add" disabled={!canBeAdd} label="New" />&nbsp;
        <PrimaryButton name ='oim-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name ='oim-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name ='oim-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteMbl}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name ='oim-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton name ='oim-list-viewBillings-button' size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
        <PrimaryButton name='oim-list-deleteHistory-button' size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>&nbsp;
        <PrimaryButton name='oim-list-trackingRq-button' size="regular" onClick={() => trackRequestFunc(JobNames.OIMbl)}>Tracking RQ</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_OIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function MblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OiMblListItem>) {
  return data.map(d => ({
    ...d,
    // shipmentType: formatShipmentType(d.shipmentType),
  }));
}

function MblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({ onFunction: onFunctionKey });

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.OIMbl);

  const { create, copy, edit, view, switchToHbl, switchToContainer, switchToAms, viewBillings, viewProfit } = useSelectedMblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToHbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F4") {
      switchToContainer();
    } else if (unprocessedFkey === "SHIFT+F4") {
      switchToAms();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }
    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'SHIFT+F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  /* pt211223
  async function loadInfoAreaInvoiceBillCrDb(id:string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions:ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      
      rowRenderers: [
        { accessor: 'date', Cell: TextRenderer },
        { accessor: 'category', Cell: TextRenderer },
        // @ts-ignore:next-line
        { accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting) },
        { accessor: 'companyName', Cell: TextAlignLeftRenderer },
        { accessor: 'cur', Cell: TextRenderer },
        // @ts-ignore:next-line
        { accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur) },
        // @ts-ignore:next-line
        { accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur) },
        // @ts-ignore:next-line
        { accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true) },
      ],
    };
  
    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }
*/
  const infoHeadline = `MBL No: ${(jobListContext.selectedElement as OiMblListItem|null)?.mblNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanImportMbl}
      jobName={JobNames.OIMbl}
      //entityId={(jobListContext.selectedElement as OceanImportMblPreview|null)?.id}
      jobId={(jobListContext.selectedElement as OiMblListItem|null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for MBL List screen
 *
 * @class MblListView
 * @extends {AbstractListView}
 */
 class MblListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.OIMbl, 'OiMblListItem',
      OiMblListItem.calculateSearchParameters(search, OiMblListItem.MapSearchFields, ['shipmentType', 'lclFcl', 'moveType']),
      1,
      search.pageSize);

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'lclFcl',   //'containerMode',
        renderer: LclFclFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      // {
      //   accessor: 're',
      //   renderer: RailFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'invStat',    //'inFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v, 
      },
      {
        accessor: 'billStat',   //'biFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'crDbStat', //crdbFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    const useBranch = systemSettings?.enableBranch ?? false;
    const listType = this.suntekSettings?.oceanAir?.useLotNumber ? OimListType.UseLot : OimListType.Normal;

    return OiMblListItem.getExportCollection(listType, useTrackingService, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === 'recognized') { colRenderer.Cell = RecognizedRenderer; }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      // { accessor:'hblCount', Cell: HblRenderer, Header: () => <span><u>HBL</u>(s)</span> },
      else if(x.dataIndex === 'hblCount') {
        colRenderer.Cell = HblRenderer;
        colRenderer.Header = () => <span><u>HBL</u>(s)</span>;
      }
      else if (x.dataIndex === 'oFrt') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'lastEvent') colRenderer.Cell = TrackEventNameRenderer;
      // else if (x.dataIndex === 're') { <250213 jhlee - R컬럼 제거 />
      //   colRenderer.Cell = RailRenderer;
      // }
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OIMbl} />;;
        colRenderer.Header =  () => <div><img style={{float:'left'}} height="16px" src={useDarkMode ? cntrWhite : cntrBlack} alt='' />Container Tracking</div>;
      }
      // else if(x.dataIndex === 'containerNo') {
      //   colRenderer.Cell = CntrNoRenderer;
      // }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.type === XCol.XCellType.Double) colRenderer.Cell = FloatRenderer;
      else if (x.dataIndex === 'chbRspCode') colRenderer.Cell = ChbRenderer;
      
      if (x.dataIndex === 'eBl' || x.dataIndex === 'expRls') {
        colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      if (x.dataIndex === 'shipmentType') {
        colRenderer.Cell = ShipmentTypeRenderer;
      }
      if (x.dataIndex === 'lclFcl') {
        colRenderer.Cell = LclFclRenderer;
      }
      return colRenderer;
    });
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'recognized', changedValue: (value: any)=> { return !value['recognized'] ? '' : value['recognized']}});
    colRenderer.push({accessor: 'lastEvent', changedValue: (value: any)=> { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '')}});
    colRenderer.push({accessor: 'te', changedValue: (value: any)=> { return nullableCheckBoxValue(value['te'])}});
    colRenderer.push({accessor: 're', changedValue: (value: any)=> { return nullableCheckBoxValue(value['re'])}});
    //colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { return formatLclFcl(value)}});
    colRenderer.push({accessor: 'eBl', changedValue: (value: any)=> { return nullableCheckBoxValue(value['eBl'])}});
    colRenderer.push({accessor: 'expRls', changedValue: (value: any)=> { return nullableCheckBoxValue(value['expRls'])}});
    colRenderer.push({accessor: 'shipmentType', changedValue: (value: any)=> { return formatShipmentType(value['shipmentType'])}});
    colRenderer.push({accessor: 'lclFcl', changedValue: (value: any)=> { return formatLclFcl(value['lclFcl'])}});
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { 
      let text = '';
      if(value['trType'] === 'C' || value['trType'] === 'M'){
        switch(value['trStatus']){
          case 'Q':
            text = 'Start to Request';
            break;
          case 'failed':
            text = 'Invalid or Error';
            break;
          case 'tracking_stopped':
            text = 'End of Tracking';
            break;
          default:
            text = 'Under Movement';
            break;
        }
      }
      return text;
    }});
    colRenderer.push({accessor: 'trStatus2', changedValue: (value: any)=> { 
      let text = '';
      if(value['trType'] === 'C' || value['trType'] === 'M'){
        switch(value['trStatus2']){
          case 'Q':
            text = 'Start to Request';
            break;
          case 'failed':
            text = 'Invalid or Error';
            break;
          case 'tracking_stopped':
            text = 'End of Tracking';
            break;
          default:
            text = 'Under Movement';
            break;
        }
      }
      return text;
    }});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    //return oceanImportMblList;
    const tsettings = oceanImportMblList;
    const cols = OiMblListItem.getExportCollection(
      this.suntekSettings?.oceanAir?.useLotNumber ? OimListType.UseLot : OimListType.Normal, 
      suntekSettings?.company?.trackingService ?? false,
      systemSettings?.enableBranch ?? false
      );

    // const getFilterType = (x: XCol.XExportColumn) => {
    //   if (x.dataIndex === 'eBl' || x.dataIndex === 'expRls')
    //   return XCol.XCellType.String;
    // }

    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
    
  }

  getTableDomIdSuffix(): string {
    let domIdSuffix = ''; 
    if (this.suntekSettings?.oceanAir?.useLotNumber) domIdSuffix = '-uselotoim';
    if (this.suntekSettings?.company?.trackingService) domIdSuffix += '-trackingService';

    return domIdSuffix;
  }

   renderCommands() {
     return (
       <MblListCommands />
     );
   }

  renderBeforeConfigureButton() {
    return (
      <MblListToolbar />
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <MblListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OiMblListItem) {
    return row && row.id ? `/oceanImport/mbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'MBL List';
  };

   renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any): React.ReactNode | null {
     if (!rowId) {
       return null;
     }

     function onCloseMilestonePopup() {
       const storageKey = `oi-mbl-milestone-${rowId}`;
       fastStorage[storageKey] = null;
       context.setRowExtrasId(null);
     }

     function onCloseTracking49Popup() {
       const storageKey = `oim-trackrequest-${rowId}`;
       fastStorage[storageKey] = null;
       context.setRowExtrasId(null);
       context.setTrackingRequestEmailList(undefined);
       vcResult = '';
     }

     function getTrackRequestTitle(trStatus: string) {
       return 'Tracking Request' + (!_.isEmpty(trStatus) && trStatus !== 'Q' ? ` - ${trStatus.toUpperCase().replace('_', ' ')}` : '');
     }

     if (!_.isUndefined(context.trackingRequestEmailList)) {
        return (
          <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseTracking49Popup} draggable isOpen title={getTrackRequestTitle(cell.row.original.trStatus)} width="500px">
            <TrackingRequest
              jobId={rowId}
              storageKey={`oim-trackrequest-${rowId}`}
              onClose={onCloseTracking49Popup}
              jobName={JobNames.OIMbl}
              trStatus={cell.row.original.trStatus}
              trType={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? (vcResult === RequestType.bl ? 'M' : 'C') : cell.row.original.trType}
              mode={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? 'new' : 'view'}
              vcResult={vcResult}
            />
          </IfmsModal>
        );
     }
     else
       return (
         <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseMilestonePopup} draggable isOpen title="Container Status Update" width="760px">
           <MblMilestonePopup mblId={rowId} storageKey={`oi-mbl-milestone-${rowId}`} onClose={onCloseMilestonePopup} isView={false} />
         </IfmsModal>
       );
   }


   renderAdditionalCommands() {
     return <JobListSuntekCommand jobName={JobNames.OIMbl} keyProp='id' showAdjustBalance={false} />;
   }

   hasRightClickContext(): boolean {
     return true;
   }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} column={context.column} isStatus = {context.status}/>;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    //#1607
    // return <AfterMemoLogButtonCommands />
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  useLogHistory(): boolean {
    return true;
  }
};

export default MblListView;
